export const LOAN_APPROVAL_PAGE_NAME = "LoanApprovalPage";

function normalize(value) {
    return (value || "").trim().toLowerCase();
}

export function getUserPersonaNames(user) {
    return (user?.personas || []).map(persona => (persona?.entityName || "").trim()).filter(Boolean);
}

/**
 * Resolves the workflow type assigned in MongoDB for the user's persona
 * at the current milestone.
 *
 * This function is fail closed. Missing config, milestone entries,
 * mappings, or user persona matches always return hasAccess: false.
 */
export function getMilestonePersonaAccess({ user, currentMilestone, permissionConfig }) {
    const userPersonaNames = getUserPersonaNames(user);

    const milestonePermissions = Array.isArray(permissionConfig?.milestonePermissions) ? permissionConfig.milestonePermissions : [];

    const milestonePermission = milestonePermissions.find(item => normalize(item?.milestoneName) === normalize(currentMilestone));

    if (!milestonePermission) {
        return {
            hasAccess: false,
            matchedPersona: "",
            workflowType: "",
            reason: "MILESTONE_PERMISSION_NOT_FOUND"
        };
    }

    const personaMappings = Array.isArray(milestonePermission?.personaMappings) ? milestonePermission.personaMappings : [];

    const matchedMapping = personaMappings.find(mapping => userPersonaNames.some(userPersonaName => normalize(userPersonaName) === normalize(mapping?.personaName)));

    if (!matchedMapping || !matchedMapping.workflowType) {
        return {
            hasAccess: false,
            matchedPersona: "",
            workflowType: "",
            reason: "PERSONA_PERMISSION_NOT_FOUND"
        };
    }

    return {
        hasAccess: true,
        matchedPersona: matchedMapping.personaName,
        workflowType: matchedMapping.workflowType,
        reason: ""
    };
}
